export type performancePages =
  | "volume"
  | "oao"
  | "brand-health-index"
  | "image-attributes"
  | "buzz-tracking"
  | "segment-volume-tiv"
  | "brand-market-share"
  | "market-share-by-channel"
  | "tp"
  | "tpva"
  | "tech-awareness"
  | "brand-kpi-trend"
  | "brand-kpi-summary"
  | "purchase-funnel"
  | "nim"
  | "nim-latest"
  | "sov/som"
  | "rv"
  | "image-snapshot"
  | "monthly-table-for-download"
  | "quarterly-table-for-download"
  | "yearly-table-for-download"
  | "rv-table-for-download";

export const pages: { pageId: performancePages; pageName: string }[] = [
  {
    pageId: "volume",
    pageName: "Volume",
  },
  {
    pageId: "oao",
    pageName: "OaO",
  },
  {
    pageId: "brand-health-index",
    pageName: "Brand Health Index",
  },
  {
    pageId: "image-attributes",
    pageName: "Image",
  },
  {
    pageId: "segment-volume-tiv",
    pageName: "Segment TIV",
  },
  {
    pageId: "brand-market-share",
    pageName: "Market Share",
  },
  {
    pageId: "market-share-by-channel",
    pageName: "Market Share by Channel",
  },
  {
    pageId: "tp",
    pageName: "TP",
  },
  {
    pageId: "tpva",
    pageName: "TPVA",
  },
  {
    pageId: "tech-awareness",
    pageName: "Tech Awareness",
  },
  {
    pageId: "brand-kpi-trend",
    pageName: "Brand KPI trend",
  },
  {
    pageId: "brand-kpi-summary",
    pageName: "Brand KPI summary",
  },
  { pageId: "purchase-funnel", pageName: "Purchase Funnel" },
  {
    pageId: "buzz-tracking",
    pageName: "Buzz / ATTN / Ad AWA",
  },
  {
    pageId: "nim",
    pageName: "NIM",
  },
  {
    pageId: "nim-latest",
    pageName: "NIM Latest",
  },
  {
    pageId: "sov/som",
    pageName: "SOV/SOM",
  },
  {
    pageId: "rv",
    pageName: "RV",
  },
  {
    pageId: "image-snapshot",
    pageName: "Image Snapshot",
  },
  { pageId: "monthly-table-for-download", pageName: "Table for download (monthly)" },
  { pageId: "quarterly-table-for-download", pageName: "Table for download (quarterly)" },
  { pageId: "yearly-table-for-download", pageName: "Table for download (yearly)" },
  { pageId: "rv-table-for-download", pageName: "Table for download (RV)" },
];

export const BRAND_HEALTH_INDEX_CATEGORY = "index";

export const pageTooltipText: Record<string, string> = {
  "purchase-funnel": "Purchase funnel represents the sequential stages a consumer goes through from initial aided awareness, to consideration, to purchase intent.YouGov has a customizable section to test adhoc questions, which may vary depending on region. As shown here, two model- level questions are tested and are only available for Awareness and Consideration.",
  oao: "Overall Opinion: <br />A metric to measure consumers' favorability towards a brand. It is part of the Purchase Funnel, following Familiarity.",
  "image-attributes": "Captures perceptions associated with each brand or model across emotional / functional attributes. Attributes may vary by market.",
  "segment-volume-tiv": "Segment Total Industrial Volume: The number of vehicles sold or registered within each segment in a given time period",
  "market-share-by-channel": "Percentage of total vehicle sales attributed to different sales channels (e.g. fleet, rental, retail, internal, etc.)",
  "tp": "Transaction Price : <br />The average price at which the vehicle was actually sold, including a discount after negotiation between dealership and purchaser.",
  "tpva": "Value Adjusted Transaction Price : <br />Value adjusted price metric that compares transcation prices while controlling for differences in vehicle equipment or feature level<br /><br />・TPVA>100 = Nissan is cheaper than competitors at same equipment level<br />・TPVA<100 = Nissan is more expensive than competitor at same equipment level",
  "nim": "Nissan Intelligent Mobility: NIM refers to Nissan's brand strategy to lead in future mobility through innovations in EV, AD and connected technologies. NIM measures consumer perception and association with Nissan in each of these strategic domains (e.g., Top of Mind for EV, Top of Mind for AD, etc.). ",
  "sov/som": "SOV/SOM is a metric to assess if a brand is overspending or underspending relative to its market share. <br />SOV = Share of Voice, share of advertising in the industry <br />SOM = Market Share <br /><br />・SOV/SOM>1.0: Advertising spend exceeds market share level <br />・SOV/SOM<1.0: Advertising spend is below market share level Note: Calculation for SOV varies by markets",
  "rv": "Residual Value: <br />Future market value of a vehicle at the end of the lease / ownership period.",
  "tech-awareness": "Tracks awareness of Nissan's electrified powertrain technologies - ePower, E-Tech, Hybrid and eHybrid - over time."
}